// Helper to get a Json object from a Json file
export async function getJson(url) {
    if (!url) throw new Error('URL is empty or undefined');

    // Fetch the file
    const response = await fetch(url);

    // If an error occur throw the message
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

    // get the Json from the response and return it
    return await response.json();
}
